export default __webpack_public_path__ + "static/media/documet.be5e6d5a.svg";